import db from '@/umcc/db'

export default {
  namespaced: true,

  state: {
    isCollapse: false,
    user: db.user,
    routes: [],
    versionRemind: false
  },

  getters: {},

  actions: {},

  mutations: {
    setVersionRemind (state, val) {
      state.versionRemind = val
    },
    changeCollapse (state) {
      state.isCollapse = !state.isCollapse
    },
    setUser (state, user) {
      state.user = user
      db.user = user
    },
    setRoutes (state, routes) {
      state.routes = routes
    }
  }
}
